module.exports = __webpack_public_path__ + "img/pump-west.eaedab27.png";